(function () {
  // prevent double init
  if (window.__PW_BTT_INIT__) return;
  window.__PW_BTT_INIT__ = true;

  function qs(sel, root) { return (root || document).querySelector(sel); }

  const btn = qs('.pw-btt');
  if (!btn) return;

  function setVisible(isVisible) {
    btn.classList.toggle('is-visible', isVisible);
    btn.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  function update() {
    // show after some scroll
    setVisible(window.scrollY > 700);

    // if sticky ATC is visible, lift above it
    const sticky = qs('#pw-sticky-atc');
    if (sticky && sticky.classList.contains('is-visible')) {
      const h = sticky.offsetHeight || 72;
      document.documentElement.style.setProperty('--pw-sticky-h', h + 'px');
      document.documentElement.classList.add('pw-has-sticky');
    } else {
      document.documentElement.classList.remove('pw-has-sticky');
    }
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  let ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  document.addEventListener('DOMContentLoaded', update);
  update();
})();

(function () {
  const btn = document.getElementById('pw-back-to-top');
  if (!btn) return;

  // Helper: parse "rgb(a)" -> {r,g,b,a}
  function parseRGBA(str) {
    if (!str) return null;
    const m = str.match(/rgba?\(([^)]+)\)/i);
    if (!m) return null;
    const parts = m[1].split(',').map(s => s.trim());
    const r = parseFloat(parts[0]);
    const g = parseFloat(parts[1]);
    const b = parseFloat(parts[2]);
    const a = parts.length > 3 ? parseFloat(parts[3]) : 1;
    if ([r,g,b,a].some(v => Number.isNaN(v))) return null;
    return { r, g, b, a };
  }

  function isTransparent(rgba) {
    return !rgba || rgba.a === 0;
  }

  // Walk up DOM from element under the button until we find a non-transparent background
  function findSolidBgColor(el) {
    let cur = el;
    while (cur && cur !== document.documentElement) {
      const bg = getComputedStyle(cur).backgroundColor;
      const rgba = parseRGBA(bg);
      if (rgba && !isTransparent(rgba)) return rgba;
      cur = cur.parentElement;
    }
    // Fallback to body/html
    const bodyBg = parseRGBA(getComputedStyle(document.body).backgroundColor);
    if (bodyBg && !isTransparent(bodyBg)) return bodyBg;

    const htmlBg = parseRGBA(getComputedStyle(document.documentElement).backgroundColor);
    if (htmlBg && !isTransparent(htmlBg)) return htmlBg;

    // Final fallback: treat as light
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  // Relative luminance quick check
  function luminance({ r, g, b }) {
    // simple perceived brightness (fine for switching)
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  function setMode(mode) {
    btn.classList.toggle('is-dark', mode === 'dark');
    btn.classList.toggle('is-light', mode === 'light');
  }

  // Sample background under button (using its center point)
  function update() {
    const rect = btn.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const cx = Math.round(rect.left + rect.width / 2);
    const cy = Math.round(rect.top + rect.height / 2);

    // Temporarily ignore the button itself while sampling
    btn.style.pointerEvents = 'none';
    const under = document.elementFromPoint(cx, cy);
    btn.style.pointerEvents = '';

    const bg = findSolidBgColor(under || document.body);
    const lum = luminance(bg);

    // If background is dark, button should be light (white). If background is light, button should be dark.
    // Your screenshots: over white content -> dark button, over footer -> light button
    setMode(lum < 0.45 ? 'light' : 'dark');
  }

  // Run on scroll/resize, but not constantly (rAF throttle)
  let ticking = false;
  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('DOMContentLoaded', requestUpdate);

  // If your theme loads sections dynamically, this helps:
  document.addEventListener('shopify:section:load', requestUpdate);

  // Initial state
  requestUpdate();
})();

// PW – Choose your set → scroll to FBT
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.pw-product-form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    const choice = form.querySelector('input[name="pw_set_choice"]:checked');
    if (!choice || choice.value !== 'case') return;

    const caseVariantId = form.dataset.caseVariantId;
    if (!caseVariantId) return; // fallback: allow normal submit

    e.preventDefault();

    const mainVariantId = form.querySelector('input[name="id"]').value;

    try {
      // Add sunglasses
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: mainVariantId,
          quantity: 1
        })
      });

      // Add case
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: caseVariantId,
          quantity: 1
        })
      });

      window.location.href = '/cart';
    } catch (err) {
      console.error('Case bundle add failed', err);
      form.submit(); // hard fallback
    }
  });
});

function pulseFBT(){
  // Prefer a real anchor if you have it, otherwise fallback to the FBT container
  var target =
    document.querySelector('#pw-fbt') ||
    document.querySelector('#pw-atc-sentinel') ||
    document.querySelector('.pw-fbt-inline');

  if (!target) return;

  target.scrollIntoView({behavior:'smooth', block:'start'});

  var box = document.querySelector('.pw-fbt-inline');
  if (!box) return;

  box.classList.add('pw-fbt-pulse');
  window.setTimeout(function(){ box.classList.remove('pw-fbt-pulse'); }, 2400);
}